import { ITemplateScope } from "AngularFormly";
import { Field } from "../../model/ProcessApi";
import { INgModelController, IPromise } from "angular";

export interface IWorkItemScope extends ITemplateScope {
  workItemController: WorkItemController;
}

export class WorkItemController {
  static $inject = ["$scope"];

  protected initialValue: any;

  constructor(protected readonly $scope: IWorkItemScope) {
    $scope.workItemController = this;
    this.setInitialValue($scope.model?.value);
  }

  protected setInitialValue(value: any) {
    this.initialValue = value;
  }

  valueHasChanged(): boolean {
    return this.$scope.model!.value !== this.initialValue;
  }

  get field(): Field {
    return this.$scope.options.data.field;
  }

  get id(): string {
    return (<any>this.$scope.options).id;
  }

  get formField(): INgModelController {
    return this.$scope.form[this.id];
  }

  setValue(value: any) {
    this.fireCommand("setValue", { Value: value });
    this.setInitialValue(value);
  }

  fireCommand(commandName: string, argument: any): IPromise<any> {
    const data = this.$scope.options.data ?? {};

    return data.itemCommandHandler(data.field, commandName, argument);
  }

  get fieldActive(): boolean {
    return this.field.Status === "Active" && this.userAuthorized;
  }

  get userAuthorized(): boolean {
    return this.field.UserAuthorized;
  }
}
